import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@repo/utils";

const textareaVariants = cva(
  [
    "placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input w-full rounded-surface border bg-card px-3 py-2 text-base shadow-xs transition-[color,box-shadow,border-color] duration-150 hover:border-charte-line-accent outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
    "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
    "aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
  ],
  {
    variants: {
      fieldSizing: {
        fixed: "min-h-[80px]",
        content: "field-sizing-content min-h-16",
      },
    },
    defaultVariants: {
      fieldSizing: "fixed",
    },
  }
);

export interface TextareaProps
  extends React.ComponentProps<"textarea">,
    VariantProps<typeof textareaVariants> {}

function Textarea({ className, fieldSizing, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(textareaVariants({ fieldSizing }), className)}
      {...props}
    />
  );
}

export { Textarea };
